export interface SalesPole {
  id: string
  main: string[]
  secondary: string[]
  leads: string[]
}

export const POLES_BY_COUNTRY: Record<string, SalesPole[]> = {
  fr: [
    {
      id: 'inbound_energy',
      main: ['leadAssistance', 'leadAxaBillProtection', 'leadCarbonOffset', 'leadVoltalisBizdev'],
      secondary: ['leadProxiserve', 'leadRetentionVa', 'leadCentury21'],
      leads: ['leadAssurance', 'leadTelecom', 'leadAssuranceEmprunteur', 'leadEnergyProBtob', 'leadTucoenergie'],
    },
    {
      id: 'inbound_telecom',
      main: ['leadAssistance', 'leadCarbonOffset', 'leadProtected'],
      secondary: ['leadRetentionVa', 'leadCentury21'],
      leads: ['leadTelecomEnergy', 'leadAssurance', 'leadAssuranceEmprunteur', 'leadTelecomSat'],
    },
    {
      id: 'inbound_insurance',
      main: ['leadAssistance', 'leadAxaBillProtection', 'leadCarbonOffset', 'leadProtected'],
      secondary: ['leadRetentionVa'],
      leads: ['leadTelecomEnergy', 'leadTelecom', 'leadAssuranceEmprunteur'],
    },
    {
      id: 'white_label',
      main: ['leadAssistance', 'leadAxaBillProtection', 'leadCarbonOffset', 'leadVoltalisBizdev', 'leadProtected'],
      secondary: ['leadRetentionVa', 'leadAssuranceEmprunteurMeilleurTaux'],
      leads: [
        'leadTelecomEnergy',
        'leadAssurance',
        'leadAssuranceEmprunteur',
        'leadEnergyProPlaceDesEnergies',
        'leadEddyProprietaire',
        'leadMutuelleSantiane',
      ],
    },
    {
      id: 'business_developer',
      main: ['leadAssistance', 'leadAxaBillProtection', 'leadCarbonOffset', 'leadVoltalisBizdev', 'leadProtectedClub'],
      secondary: ['leadEmoovz'],
      leads: [
        'leadAssurance',
        'leadAssuranceEmprunteur',
        'leadEnergyProBtob',
        'leadMovingNextories',
        'leadAssuranceProSante',
        'leadEnergygo',
      ],
    },
    {
      id: 'performance',
      main: ['leadAssistance', 'leadCarbonOffset', 'leadVoltalisBizdev', 'leadProtected'],
      secondary: ['leadCentury21'],
      leads: ['leadTelecom', 'leadAssurance', 'leadAssuranceEmprunteur', 'leadEnergyProBtob', 'leadEddyProprietaire'],
    },
    {
      id: 'water',
      main: ['leadAssistance', 'leadAxaBillProtection', 'leadCarbonOffset', 'leadVoltalisBizdev', 'leadProtected'],
      secondary: ['leadRetentionVa', 'leadInteractionWater', 'leadCentury21'],
      leads: ['leadTelecom', 'leadAssurance', 'leadAssuranceEmprunteur', 'leadEnergyProBtob'],
    },
    {
      id: 'outbound',
      main: ['leadAssistance', 'leadCarbonOffset', 'leadVoltalisBizdev'],
      secondary: ['leadRetentionVa', 'leadInteractionWater'],
      leads: [
        'leadTelecomEnergy',
        'leadTelecom',
        'leadAssurance',
        'leadAssuranceEmprunteur',
        'leadMovingNextories',
        'leadTucoenergie',
        'leadEddyProprietaire',
      ],
    },
  ],
}

export const OTHER_SALES_POLE_ID = 'other_sales'

export const polesOf = (country?: string | null): SalesPole[] => POLES_BY_COUNTRY[country ?? ''] ?? []

export const withOtherSales = (poles: SalesPole[], available: string[]): SalesPole[] => {
  if (poles.length === 0) return poles

  const inPoles = new Set(poles.flatMap(({ main, secondary, leads }) => [...main, ...secondary, ...leads]))
  const others = available.filter(key => !inPoles.has(key))

  return others.length > 0 ? [...poles, { id: OTHER_SALES_POLE_ID, main: others, secondary: [], leads: [] }] : poles
}
